/* eslint-disable */
import { Box, Button, Card, CircularProgress, styled } from "@mui/material";
import BackButton from "../BackButton/BackButton";
import SyncIcon from "@mui/icons-material/Sync";

const CardWrapper = styled(Card)(({ theme }) => ({
  padding: "16px 16px 16px 16px",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none !important",
  "& .ContentWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& .ActionBtnWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "15px",
      "@media screen and (max-width:600px)": {
        flexDirection: "column",
        alignItems: "stretch",
      },
      "& button": {
        textTransform: "none",
        backgroundColor: theme.palette.primary.main,
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "6px 16px",
        gap: "5px",
        minWidth: "162px",
        "@media screen and (max-width:600px)": {
          width: "100%",
          padding: "6px 22px",
        },
        "&:focus": {
          outline: "0",
        },
        "&.Mui-disabled": {
          opacity: "0.3",
        },
        "& svg": {
          "&.Rotate": {
            animation: "rotate 2s infinite linear",
            "@keyframes rotate": {
              "0%": { transform: "rotate(360deg)" },
              "100%": { transform: "rotate(0deg)" },
            },
          },
        },
        "& .LoaderWrapper": {
          width: "24px !important",
          height: "24px !important",
          "& svg": { color: "#ffffff" },
        },
      },
    },
  },
}));

function IssuesFlagHeader({ handleNextClick, selectedFlags, loader, loaderSync, issuesData, disabledSync, handleSyncData }) {
  return (
    <CardWrapper>
      <Box className="ContentWrapper">
        <BackButton sx={{ "& button": { marginBottom: "0 !important" } }} />
        <Box className="ActionBtnWrapper">
          <Button disabled={!issuesData?.sync || disabledSync || loader} onClick={() => handleSyncData()}>
            <SyncIcon className={loaderSync ? "Rotate" : ""} />
            Sync new data
          </Button>
          <Button onClick={handleNextClick} disabled={selectedFlags.length === 0 || loader}>
            {loader ? <CircularProgress className="LoaderWrapper" /> : "Create kanban view"}
          </Button>
        </Box>
      </Box>
    </CardWrapper>
  );
}

export default IssuesFlagHeader;
